import { FC, HTMLAttributes, useEffect } from "react";
import { StaticImage } from "../StaticImage";
import {
  DURATION_COIN_ANIMATION,
  KEYFRAMES_COIN,
  NB_COIN,
} from "../../../constants/animation";
import { randomInt } from "../../../models/systems";
import { useStyles } from "./CoinsAnimation.style";
import { useWalletConfig } from "../../../hooks/useWalletConfig";

export const CoinsAnimation: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { primaryIcon } = useWalletConfig();
  const coinStart = document.getElementById("coin-start");
  const coinTarget = document.getElementById("coin-target");

  useEffect(() => {
    if (!coinStart || !coinTarget) return;
    const rectStart = coinStart.getBoundingClientRect();
    const startX = rectStart.left + rectStart.width / 2 + window.scrollX;
    const startY = rectStart.top + rectStart.height / 2 + window.scrollY;
    const rectTarget = coinTarget.getBoundingClientRect();
    const targetX =
      rectTarget.left + rectTarget.width / 2 + window.scrollX - 10;
    const targetY =
      rectTarget.top + rectTarget.height / 2 + window.scrollY - 10;
    Array.from({ length: NB_COIN }).forEach((_, i) => {
      const coinFly = document.getElementById(`coin-fly-${i}`);
      if (!coinFly) return;
      const randomLeft = randomInt(-50, 50);
      const randomTop = randomInt(-25, 25);
      const leftCoordinate = (rate: number, random: number) =>
        startX + (targetX - startX) * rate + random;
      const topCoordinate = (rate: number, random: number) =>
        startY + (targetY - startY) * rate + random;
      coinFly.animate(
        KEYFRAMES_COIN.map(({ offset, opacity, hasRandom }) => ({
          offset,
          left: `${leftCoordinate(offset, hasRandom ? randomLeft : 0)}px`,
          top: `${topCoordinate(offset, hasRandom ? randomTop : 0)}px`,
          opacity,
        })).concat({
          offset: 1,
          left: `${targetX}px`,
          top: `${targetY}px`,
          opacity: 0,
        }),
        {
          duration: DURATION_COIN_ANIMATION,
          easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          fill: "forwards",
        },
      );
    });
  }, [coinStart, coinTarget]);

  return (
    <div>
      {Array.from({ length: NB_COIN }).map((_, i) => (
        <StaticImage
          key={i}
          src={primaryIcon.src}
          src2x={primaryIcon.src2x}
          src3x={primaryIcon.src3x}
          className={classes.coin}
          id={`coin-fly-${i}`}
        />
      ))}
    </div>
  );
};
